import { render, staticRenderFns } from "./answerView.vue?vue&type=template&id=0b52dc24&scoped=true"
import script from "./answerView.vue?vue&type=script&lang=js"
export * from "./answerView.vue?vue&type=script&lang=js"
import style0 from "./answerView.vue?vue&type=style&index=0&id=0b52dc24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52dc24",
  null
  
)

export default component.exports